import React from "react"

import PurpleLogo from "../../images/logo/premagic-logo@2xl.svg"
import GdprBadge from "../../images/campaign/gdpr-badge.svg"
import EncryptedBadge from "../../images/campaign/encrypted-security-badge.svg"
import Squiggle from "../../images/campaign/squiggle.svg"

type Props = {
  eventName?: string
}

export default function CampaignFooter({ eventName }: Props) {
  const platformLabel = eventName
    ? `Event marketing platform for ${eventName}`
    : "Event marketing platform for events"

  return (
    <footer className="flex flex-col items-center w-full pt-8 pb-8 px-4">
      <div className="flex items-center justify-center gap-6">
        <img src={GdprBadge} alt="GDPR Complaint" className="h-8 w-auto" />
        <img
          src={EncryptedBadge}
          alt="Encrypted Security"
          className="h-8 w-auto"
        />
      </div>

      <div className="mt-6">
        <img src={Squiggle} alt="" aria-hidden="true" className="h-1.5 w-auto" />
      </div>

      <div className="mt-6 flex flex-col items-center gap-1.5">
        <span className="text-[#666666] text-[14px] font-semibold leading-none">
          Powered by
        </span>
        <img src={PurpleLogo} alt="Premagic" width={119} />
      </div>

      <p className="mt-1.5 text-[#666666] text-[13px] text-center leading-snug">
        {platformLabel}
      </p>
    </footer>
  )
}
